import React, { useMemo } from 'react';
import Button from '@mui/material/Button';
import { TASK_MODULES } from '@/common/constants/constants';
import { Immediate, Legal, Main, Asset, Closing } from '@/common/containers/ModuleOverview/components/index';
import styles from '@/common/containers/ModuleOverview/styles.less';

const ModuleOverview = ({ open = false, module, onClose }) => {
  const Form = useMemo(() => {
    if (!open) return null;
    const { IMMEDIATE, LEGAL, MAIN, ASSET, CLOSING } = TASK_MODULES;
    const forms = {
      [IMMEDIATE]: Immediate,
      [LEGAL]: Legal,
      [MAIN]: Main,
      [ASSET]: Asset,
      [CLOSING]: Closing,
    };
    const Component = forms[module];

    return <Component />;
  }, [open, module]);

  if (!open) return null;
  return (
    <div className={styles.block}>
      <div className={styles.blockContent}>{Form}</div>
      <Button
        sx={{ width: 'fit-content', marginLeft: 'auto' }}
        variant="contained"
        onClick={onClose}
      >
        Continue
      </Button>
    </div>
  );
};

export default ModuleOverview;
